import React, { useEffect, useState } from 'react';
import {
    Grid, TextField, Button, Box, Typography, Card, CardContent,
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Avatar, IconButton, Dialog, DialogTitle, DialogContent,
    DialogActions, FormControl, InputLabel, Select, MenuItem,
    Checkbox, FormControlLabel, FormGroup, FormLabel, Snackbar, Alert,
    Chip, CircularProgress, InputAdornment, Tabs, Tab
} from '@mui/material';
import { Add, Edit, Delete, Search, Phone } from '@mui/icons-material';
import axios from 'axios';
import { base_url } from '../../utils/api-routes';

const api_urls = base_url + 'api/';

const AstrologerManage = () => {
    const [loading, setLoading] = useState(false);
    const [astrologers, setAstrologers] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [openDialog, setOpenDialog] = useState(false);
    const [editMode, setEditMode] = useState(false);
    const [selectedAstrologer, setSelectedAstrologer] = useState(null);
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });
    const [tabValue, setTabValue] = useState(0);
    
    const [skills, setSkills] = useState([]);
    const [expertise, setExpertise] = useState([]);
    const [mainExpertise, setMainExpertise] = useState([]);
    const [remedies, setRemedies] = useState([]);
    const [languages, setLanguages] = useState([]);

    const [formData, setFormData] = useState({
        astrologerName: '', email: '', phoneNumber: '', alternateNumber: '',
        password: '', gender: 'male', dateOfBirth: '', experience: '',
        address: '', country: 'India', state: '', city: '', zipCode: '',
        language: [], skill: [], expertise: [], mainExpertise: [], remedies: [],
        preferredDays: [], startTime: '09:00', endTime: '21:00',
        chat_price: '', call_price: '', video_call_price: '',
        commission_chat_price: '', commission_call_price: '', commission_video_call_price: '',
        short_bio: '', long_bio: '',
        account_holder_name: '', account_name: '', account_number: '',
        IFSC_code: '', account_type: 'savings', panCard: '', aadharNumber: '',
        rating: 4.5, follower_count: 0, chat_status: 'offline', call_status: 'offline', isVerified: false
    });

    const preferredDaysList = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

    useEffect(() => {
        fetchAstrologers();
        fetchDropdownData();
    }, []);

    const fetchDropdownData = async () => {
        try {
            const [skillsRes, expertiseRes, mainExpertiseRes, remediesRes, languagesRes] = await Promise.all([
                axios.get(api_urls + 'admin/get-skill'),
                axios.get(api_urls + 'admin/get-all-expertise'),
                axios.get(api_urls + 'admin/get-all-main-expertise'),
                axios.get(api_urls + 'admin/view-remedy'),
                axios.get(api_urls + 'admin/get_language')
            ]);
            setSkills(skillsRes.data?.skills || []);
            setExpertise(expertiseRes.data?.expertise || []);
            setMainExpertise(mainExpertiseRes.data?.mainExpertise || []);
            setRemedies(remediesRes.data?.remedies || []);
            setLanguages(languagesRes.data?.languageData || []);
        } catch (error) {
            console.error('Error fetching dropdown data:', error);
            showSnackbar('Error loading form data', 'error');
        }
    };

    const fetchAstrologers = async () => {
        setLoading(true);
        try {
            const response = await axios.get(api_urls + 'astrologer/get-all-astrologers');
            if (response.data?.success) {
                setAstrologers(response.data.astrologer || []);
            }
        } catch (error) {
            console.error('Error fetching astrologers:', error);
            showSnackbar('Error fetching astrologers', 'error');
        }
        setLoading(false);
    };

    const showSnackbar = (message, severity = 'success') => {
        setSnackbar({ open: true, message, severity });
    };

    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleCheckboxChange = (field, value) => {
        setFormData(prev => {
            const currentArray = prev[field] || [];
            if (currentArray.includes(value)) {
                return { ...prev, [field]: currentArray.filter(item => item !== value) };
            } else {
                return { ...prev, [field]: [...currentArray, value] };
            }
        });
    };

    const handleOpenDialog = (astrologer = null) => {
        if (astrologer) {
            setEditMode(true);
            setSelectedAstrologer(astrologer);
            setFormData({
                astrologerName: astrologer.astrologerName || '',
                email: astrologer.email || '',
                phoneNumber: astrologer.phoneNumber || '',
                alternateNumber: astrologer.alternateNumber || '',
                password: '',
                gender: astrologer.gender || 'male',
                dateOfBirth: astrologer.dateOfBirth ? new Date(astrologer.dateOfBirth).toISOString().split('T')[0] : '',
                experience: astrologer.experience || '',
                address: astrologer.address || '',
                country: astrologer.country || 'India',
                state: astrologer.state || '',
                city: astrologer.city || '',
                zipCode: astrologer.zipCode || '',
                language: astrologer.language || [],
                skill: astrologer.skill?.map(s => s._id || s) || [],
                expertise: astrologer.expertise?.map(e => e._id || e) || [],
                mainExpertise: astrologer.mainExpertise?.map(m => m._id || m) || [],
                remedies: astrologer.remedies?.map(r => r._id || r) || [],
                preferredDays: astrologer.preferredDays || [],
                startTime: astrologer.startTime || '09:00',
                endTime: astrologer.endTime || '21:00',
                chat_price: astrologer.chat_price || '',
                call_price: astrologer.call_price || '',
                video_call_price: astrologer.video_call_price || '',
                commission_chat_price: astrologer.commission_chat_price || '',
                commission_call_price: astrologer.commission_call_price || '',
                commission_video_call_price: astrologer.commission_video_call_price || '',
                short_bio: astrologer.short_bio || '',
                long_bio: astrologer.long_bio || '',
                account_holder_name: astrologer.account_holder_name || '',
                account_name: astrologer.account_name || '',
                account_number: astrologer.account_number || '',
                IFSC_code: astrologer.IFSC_code || '',
                account_type: astrologer.account_type || 'savings',
                panCard: astrologer.panCard || '',
                aadharNumber: astrologer.aadharNumber || '',
                rating: astrologer.rating || 4.5,
                follower_count: astrologer.follower_count || 0,
                chat_status: astrologer.chat_status || 'offline',
                call_status: astrologer.call_status || 'offline',
                isVerified: astrologer.isVerified || false
            });
        } else {
            setEditMode(false);
            setSelectedAstrologer(null);
            setFormData({
                astrologerName: '', email: '', phoneNumber: '', alternateNumber: '',
                password: '', gender: 'male', dateOfBirth: '', experience: '',
                address: '', country: 'India', state: '', city: '', zipCode: '',
                language: [], skill: [], expertise: [], mainExpertise: [], remedies: [],
                preferredDays: [], startTime: '09:00', endTime: '21:00',
                chat_price: '', call_price: '', video_call_price: '',
                commission_chat_price: '', commission_call_price: '', commission_video_call_price: '',
                short_bio: '', long_bio: '',
                account_holder_name: '', account_name: '', account_number: '',
                IFSC_code: '', account_type: 'savings', panCard: '', aadharNumber: '',
                rating: 4.5, follower_count: 0, chat_status: 'offline', call_status: 'offline', isVerified: false
            });
        }
        setTabValue(0);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setEditMode(false);
        setSelectedAstrologer(null);
    };

    const handleSubmit = async () => {
        if (!formData.astrologerName || !formData.email || !formData.phoneNumber) {
            showSnackbar('Please fill required fields: Name, Email, Phone', 'error');
            return;
        }
        if (!editMode && !formData.password) {
            showSnackbar('Password is required for new astrologer', 'error');
            return;
        }

        setLoading(true);
        try {
            const payload = { ...formData };
            if (editMode) {
                payload._id = selectedAstrologer._id;
                const response = await axios.post(api_urls + 'astrologer/update-astrologer-details', payload);
                if (response.data?.success) {
                    showSnackbar('Astrologer updated successfully');
                    fetchAstrologers();
                    handleCloseDialog();
                } else {
                    showSnackbar(response.data?.message || 'Update failed', 'error');
                }
            } else {
                const response = await axios.post(api_urls + 'admin/create-astrologer', payload);
                if (response.data?.success) {
                    showSnackbar('Astrologer added successfully');
                    fetchAstrologers();
                    handleCloseDialog();
                } else {
                    showSnackbar(response.data?.message || 'Add failed', 'error');
                }
            }
        } catch (error) {
            console.error('Error saving astrologer:', error);
            showSnackbar(error.response?.data?.message || 'Error saving astrologer', 'error');
        }
        setLoading(false);
    };

    const handleDelete = async (astrologer) => {
        if (!window.confirm('Are you sure you want to delete ' + astrologer.astrologerName + '?')) return;
        try {
            const response = await axios.post(api_urls + 'admin/delete-astrologer', { astrologerId: astrologer._id });
            if (response.data?.success) {
                showSnackbar('Astrologer deleted successfully');
                fetchAstrologers();
            }
        } catch (error) {
            showSnackbar('Error deleting astrologer', 'error');
        }
    };

    const handleStatusToggle = async (astrologer, field) => {
        try {
            const newStatus = astrologer[field] === 'online' ? 'offline' : 'online';
            const response = await axios.post(api_urls + 'astrologer/update-astrologer-details', {
                _id: astrologer._id,
                [field]: newStatus
            });
            if (response.data?.success) {
                showSnackbar(field.replace('_', ' ') + ' updated to ' + newStatus);
                fetchAstrologers();
            }
        } catch (error) {
            showSnackbar('Error updating status', 'error');
        }
    };

    const filteredAstrologers = astrologers.filter(a => 
        (a.astrologerName?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (a.email?.toLowerCase() || '').includes(searchTerm.toLowerCase()) ||
        (a.phoneNumber || '').includes(searchTerm)
    );

    const renderBasicInfoTab = () => (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <TextField fullWidth required label="Astrologer Name" name="astrologerName" value={formData.astrologerName} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField fullWidth required label="Email" name="email" type="email" value={formData.email} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField fullWidth required label="Phone Number" name="phoneNumber" value={formData.phoneNumber} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField fullWidth label="Alternate Number" name="alternateNumber" value={formData.alternateNumber} onChange={handleInputChange} />
            </Grid>
            {!editMode && (
                <Grid item xs={12} md={6}>
                    <TextField fullWidth required label="Password" name="password" type="password" value={formData.password} onChange={handleInputChange} />
                </Grid>
            )}
            <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                    <InputLabel>Gender</InputLabel>
                    <Select name="gender" value={formData.gender} onChange={handleInputChange} label="Gender">
                        <MenuItem value="male">Male</MenuItem>
                        <MenuItem value="female">Female</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField fullWidth label="Date of Birth" name="dateOfBirth" type="date" value={formData.dateOfBirth} onChange={handleInputChange} InputLabelProps={{ shrink: true }} />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField fullWidth label="Experience (years)" name="experience" type="number" value={formData.experience} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12}>
                <TextField fullWidth label="Address" name="address" multiline rows={2} value={formData.address} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={4}>
                <TextField fullWidth label="Country" name="country" value={formData.country} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={4}>
                <TextField fullWidth label="State" name="state" value={formData.state} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={4}>
                <TextField fullWidth label="City" name="city" value={formData.city} onChange={handleInputChange} />
            </Grid>
        </Grid>
    );

    const renderSkillsTab = () => (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <FormLabel component="legend">Languages</FormLabel>
                <FormGroup row>
                    {languages.map(lang => (
                        <FormControlLabel key={lang._id} control={<Checkbox checked={formData.language.includes(lang.languageName)} onChange={() => handleCheckboxChange('language', lang.languageName)} />} label={lang.languageName} />
                    ))}
                </FormGroup>
            </Grid>
            <Grid item xs={12}>
                <FormLabel component="legend">Skills</FormLabel>
                <FormGroup row>
                    {skills.map(skill => (
                        <FormControlLabel key={skill._id} control={<Checkbox checked={formData.skill.includes(skill._id)} onChange={() => handleCheckboxChange('skill', skill._id)} />} label={skill.skill} />
                    ))}
                </FormGroup>
            </Grid>
            <Grid item xs={12}>
                <FormLabel component="legend">Main Expertise</FormLabel>
                <FormGroup row>
                    {mainExpertise.map(exp => (
                        <FormControlLabel key={exp._id} control={<Checkbox checked={formData.mainExpertise.includes(exp._id)} onChange={() => handleCheckboxChange('mainExpertise', exp._id)} />} label={exp.mainExpertise} />
                    ))}
                </FormGroup>
            </Grid>
            <Grid item xs={12}>
                <FormLabel component="legend">Expertise</FormLabel>
                <FormGroup row>
                    {expertise.map(exp => (
                        <FormControlLabel key={exp._id} control={<Checkbox checked={formData.expertise.includes(exp._id)} onChange={() => handleCheckboxChange('expertise', exp._id)} />} label={exp.expertise} />
                    ))}
                </FormGroup>
            </Grid>
            <Grid item xs={12}>
                <FormLabel component="legend">Remedies</FormLabel>
                <FormGroup row>
                    {remedies.map(remedy => (
                        <FormControlLabel key={remedy._id} control={<Checkbox checked={formData.remedies.includes(remedy._id)} onChange={() => handleCheckboxChange('remedies', remedy._id)} />} label={remedy.remedy} />
                    ))}
                </FormGroup>
            </Grid>
            <Grid item xs={12}>
                <FormLabel component="legend">Preferred Days</FormLabel>
                <FormGroup row>
                    {preferredDaysList.map(day => (
                        <FormControlLabel key={day} control={<Checkbox checked={formData.preferredDays.includes(day)} onChange={() => handleCheckboxChange('preferredDays', day)} />} label={day} />
                    ))}
                </FormGroup>
            </Grid>
        </Grid>
    );

    const renderPricingTab = () => (
        <Grid container spacing={2}>
            <Grid item xs={12} md={4}>
                <TextField fullWidth label="Chat Price (Rs/min)" name="chat_price" type="number" value={formData.chat_price} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={4}>
                <TextField fullWidth label="Call Price (Rs/min)" name="call_price" type="number" value={formData.call_price} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={4}>
                <TextField fullWidth label="Video Call Price (Rs/min)" name="video_call_price" type="number" value={formData.video_call_price} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={4}>
                <TextField fullWidth label="Chat Commission (Rs/min)" name="commission_chat_price" type="number" value={formData.commission_chat_price} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={4}>
                <TextField fullWidth label="Call Commission (Rs/min)" name="commission_call_price" type="number" value={formData.commission_call_price} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={4}>
                <TextField fullWidth label="Video Call Commission (Rs/min)" name="commission_video_call_price" type="number" value={formData.commission_video_call_price} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField fullWidth label="Start Time" name="startTime" type="time" value={formData.startTime} onChange={handleInputChange} InputLabelProps={{ shrink: true }} />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField fullWidth label="End Time" name="endTime" type="time" value={formData.endTime} onChange={handleInputChange} InputLabelProps={{ shrink: true }} />
            </Grid>
            <Grid item xs={12}>
                <TextField fullWidth label="Short Bio" name="short_bio" multiline rows={2} value={formData.short_bio} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12}>
                <TextField fullWidth label="Long Bio" name="long_bio" multiline rows={4} value={formData.long_bio} onChange={handleInputChange} />
            </Grid>
        </Grid>
    );

    const renderBankTab = () => (
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <TextField fullWidth label="Account Holder Name" name="account_holder_name" value={formData.account_holder_name} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField fullWidth label="Bank Name" name="account_name" value={formData.account_name} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField fullWidth label="Account Number" name="account_number" value={formData.account_number} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField fullWidth label="IFSC Code" name="IFSC_code" value={formData.IFSC_code} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={6}>
                <FormControl fullWidth>
                    <InputLabel>Account Type</InputLabel>
                    <Select name="account_type" value={formData.account_type} onChange={handleInputChange} label="Account Type">
                        <MenuItem value="savings">Savings</MenuItem>
                        <MenuItem value="current">Current</MenuItem>
                    </Select>
                </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField fullWidth label="PAN Number" name="panCard" value={formData.panCard} onChange={handleInputChange} />
            </Grid>
            <Grid item xs={12} md={6}>
                <TextField fullWidth label="Aadhar Number" name="aadharNumber" value={formData.aadharNumber} onChange={handleInputChange} />
            </Grid>
        </Grid>
    );

    return (
        <Box sx={{ p: 3 }}>
            <Typography variant="h4" gutterBottom sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                Astrologer Management
            </Typography>

            <Box sx={{ display: 'flex', gap: 2, mb: 3, flexWrap: 'wrap' }}>
                <TextField
                    placeholder="Search by name, email or phone..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    sx={{ flex: 1, minWidth: 250 }}
                    InputProps={{ startAdornment: (<InputAdornment position="start"><Search /></InputAdornment>) }}
                />
                <Button variant="contained" color="primary" startIcon={<Add />} onClick={() => handleOpenDialog()} sx={{ px: 3 }}>
                    Add Astrologer
                </Button>
            </Box>

            <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={6} md={3}>
                    <Card sx={{ bgcolor: '#e3f2fd' }}>
                        <CardContent>
                            <Typography variant="h4">{astrologers.length}</Typography>
                            <Typography color="textSecondary">Total Astrologers</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={6} md={3}>
                    <Card sx={{ bgcolor: '#e8f5e9' }}>
                        <CardContent>
                            <Typography variant="h4">{astrologers.filter(a => a.chat_status === 'online').length}</Typography>
                            <Typography color="textSecondary">Online (Chat)</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={6} md={3}>
                    <Card sx={{ bgcolor: '#fff3e0' }}>
                        <CardContent>
                            <Typography variant="h4">{astrologers.filter(a => a.call_status === 'online').length}</Typography>
                            <Typography color="textSecondary">Online (Call)</Typography>
                        </CardContent>
                    </Card>
                </Grid>
                <Grid item xs={6} md={3}>
                    <Card sx={{ bgcolor: '#fce4ec' }}>
                        <CardContent>
                            <Typography variant="h4">{astrologers.filter(a => a.isVerified).length}</Typography>
                            <Typography color="textSecondary">Verified</Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>

            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}><CircularProgress /></Box>
            ) : (
                <TableContainer component={Paper}>
                    <Table>
                        <TableHead>
                            <TableRow sx={{ bgcolor: '#1976d2' }}>
                                <TableCell sx={{ color: 'white' }}>Astrologer</TableCell>
                                <TableCell sx={{ color: 'white' }}>Contact</TableCell>
                                <TableCell sx={{ color: 'white' }}>Pricing</TableCell>
                                <TableCell sx={{ color: 'white' }}>Status</TableCell>
                                <TableCell sx={{ color: 'white' }}>Rating</TableCell>
                                <TableCell sx={{ color: 'white' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredAstrologers.map((astrologer) => (
                                <TableRow key={astrologer._id} hover>
                                    <TableCell>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                            <Avatar src={astrologer.profileImage}>{astrologer.astrologerName?.charAt(0)}</Avatar>
                                            <Box>
                                                <Typography fontWeight="bold">{astrologer.astrologerName}</Typography>
                                                <Typography variant="caption" color="textSecondary">{astrologer.experience} yrs exp</Typography>
                                            </Box>
                                        </Box>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2"><Phone fontSize="small" sx={{ mr: 0.5, verticalAlign: 'middle' }} />{astrologer.phoneNumber}</Typography>
                                        <Typography variant="caption" color="textSecondary">{astrologer.email}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography variant="body2">Chat: Rs{astrologer.chat_price}/min</Typography>
                                        <Typography variant="body2">Call: Rs{astrologer.call_price}/min</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Chip size="small" label={astrologer.chat_status || 'offline'} color={astrologer.chat_status === 'online' ? 'success' : 'default'} onClick={() => handleStatusToggle(astrologer, 'chat_status')} sx={{ mr: 0.5, cursor: 'pointer' }} />
                                        <Chip size="small" label={astrologer.call_status || 'offline'} color={astrologer.call_status === 'online' ? 'warning' : 'default'} onClick={() => handleStatusToggle(astrologer, 'call_status')} sx={{ cursor: 'pointer' }} />
                                    </TableCell>
                                    <TableCell>
                                        <Chip label={'* ' + (astrologer.rating || 0)} size="small" color="primary" variant="outlined" />
                                    </TableCell>
                                    <TableCell>
                                        <IconButton color="primary" onClick={() => handleOpenDialog(astrologer)}><Edit /></IconButton>
                                        <IconButton color="error" onClick={() => handleDelete(astrologer)}><Delete /></IconButton>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {filteredAstrologers.length === 0 && (
                                <TableRow><TableCell colSpan={6} align="center"><Typography color="textSecondary" py={3}>No astrologers found</Typography></TableCell></TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
            )}

            <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="md" fullWidth>
                <DialogTitle>{editMode ? 'Edit Astrologer' : 'Add New Astrologer'}</DialogTitle>
                <DialogContent>
                    <Tabs value={tabValue} onChange={(e, v) => setTabValue(v)} sx={{ mb: 2 }}>
                        <Tab label="Basic Info" />
                        <Tab label="Skills & Expertise" />
                        <Tab label="Pricing & Bio" />
                        <Tab label="Bank Details" />
                    </Tabs>
                    <Box sx={{ mt: 2 }}>
                        {tabValue === 0 && renderBasicInfoTab()}
                        {tabValue === 1 && renderSkillsTab()}
                        {tabValue === 2 && renderPricingTab()}
                        {tabValue === 3 && renderBankTab()}
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>Cancel</Button>
                    <Button variant="contained" onClick={handleSubmit} disabled={loading}>
                        {loading ? <CircularProgress size={24} /> : (editMode ? 'Update' : 'Add')}
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>{snackbar.message}</Alert>
            </Snackbar>
        </Box>
    );
};

export default AstrologerManage;
